<ion-item *ngIf="false" lines="none" class="mouse bb" (click)="!expanded ? expanded = true:expanded = false">
  <h2>Your cart items</h2>
  <ion-icon slot="end" *ngIf="expanded" name="chevron-forward-outline"></ion-icon>
  <ion-icon slot="end" *ngIf="!expanded" name="chevron-down-outline"></ion-icon>
</ion-item>

<div class="list">
  <div *ngIf="db.ismobile" class="d__flex header">
    <!-- <h6 class="m-0 heading">Selected catalog products</h6> -->
    <h6 class="m-0 heading__">Your Inventory Products</h6>
    <ion-icon (click)="modalCtrl.dismiss()" class="mouse" name="close-outline"></ion-icon>
  </div>
  
  <div *ngIf="db.inventory_items && db.inventory_items.length != 0" class="" [ngClass]="is_footer?'cart_items_list': expanded ? 'h0':'h33'" >
    <div *ngIf="!expanded" class="list-view">
      <div div class="d__flex list-item animated fadeInUp" *ngFor="let item of db.inventory_items;let index = index;">
      
        <div class="image">
          <img src="{{db.product_img(item.product_image)}}" />
        </div>
        <div class="item-info">
  
        <div class="div__ d__flex just-s">
  
          <div>
            <p *ngIf="item.item" class="m-0 product__name bold_name-14">{{item.item}}</p>
            <h4 *ngIf="item.sku" [class.sku]="item.variants && item.variants[0]" class="small_name m-0">SKU : <span>{{item.sku}}</span></h4>
            <p *ngIf="item.variants && item.variants[0]" class="m-0 varient_name small_name">{{item.variants[0].combination_text}}</p>
            <!-- <ion-label *ngIf="item.attribute_html" class="prices">
              <p class="m-0 price cat-price" [innerHtml]="item.attribute_html" ></p>
            </ion-label> -->
          </div>
  
          <div class="remove_icon">
            <ion-icon (click)="db.remove_item(db.inventory_items,index,'store')"  class="icon mouse" src="assets/icon/remove.svg" slot="end"></ion-icon>
          </div>
        </div>
  
        <!-- <div class="d__flex edit_delete_con">
          <div class="edit_delete">
            <ion-icon slot="end" *ngIf="item.is_free_item != 1" src="assets/pos-icons/edit.svg" class="mouse edit__icon" (click)="edit_cart(item,index,item.quantity)"></ion-icon>
            <ion-icon slot="end" *ngIf="item.is_free_item != 1" src="assets/pos-icons/delete.svg" class="mouse trash__icon" (click)="delete_cart(item,db.cart_items.length - index - 1)"></ion-icon>
           </div>
        </div> -->
  
        </div>
      </div>
    </div>
  </div>
  
  
  
  <div *ngIf="db.inventory_items && db.inventory_items.length != 0" class="animated fadeInUp">
    <div class="d__flex clear_cart just-s">
       <ion-button (click)="db.clear_cart()" fill="clear" class="d__flex clear"><ion-icon name="trash-outline"></ion-icon> <span> Clear all</span> </ion-button>
       <h6 class="m-0 head">Total Items : <span class="value_">{{db.inventory_items.length}}</span></h6>
    </div>
    
    <ion-button (click)="db.ismobile ? submit_products() : submit.emit()" class="add_i_btn" fill="clear">Add To catalogue</ion-button>
  </div>
  
  <app-no-record-found *ngIf="db.inventory_items && db.inventory_items.length == 0" height="calc(100vh - 200px)" [column]="true" heading="There’s no product found." [image]="'assets/no-product-POS.svg'"></app-no-record-found>
</div>

